import { Play } from "lucide-react";

const VIDEOS = [
    { id: "ITlAzmHo0WM", title: "Styletto IX — Ultra-slim Rechargeable", subtitle: "Product Spotlight" },
    { id: "6JIh05d3K0s", title: "Signia Integrated Xperience Technology", subtitle: "Technology" },
    { id: "HTsiTKW1lI8", title: "Hear the Difference — Live Sound Demo", subtitle: "Sound Demo" },
];

export default function VideoSection() {
    return (
        <section className="section bg-[#0e1416] text-white relative overflow-hidden" data-testid="video-section">
            <div className="container-x">
                <div className="max-w-[680px]">
                    <p className="eyebrow !text-[#7DCDD2]">See it in action</p>
                    <h2 className="font-serif text-[40px] md:text-[56px] leading-[1.04] mt-3">
                        Official Signia videos.
                        <br />
                        <span className="italic text-[#7DCDD2]">Real technology, real results.</span>
                    </h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-12">
                    {VIDEOS.map((v, i) => (
                        <a
                            key={v.id}
                            href={`https://www.youtube.com/watch?v=${v.id}`}
                            target="_blank"
                            rel="noreferrer"
                            className="group block"
                            data-testid={`video-${i}`}
                        >
                            <div className="relative aspect-video rounded-2xl overflow-hidden bg-black">
                                <img
                                    src={`https://img.youtube.com/vi/${v.id}/maxresdefault.jpg`}
                                    alt={v.title}
                                    className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition"
                                />
                                <span className="absolute inset-0 flex items-center justify-center">
                                    <span className="w-14 h-14 rounded-full bg-white/95 text-[#0e1416] flex items-center justify-center shadow-xl group-hover:scale-110 transition">
                                        <Play size={20} className="ml-1" fill="currentColor" />
                                    </span>
                                </span>
                            </div>
                            <p className="eyebrow !text-[#7DCDD2] mt-4">{v.subtitle}</p>
                            <h3 className="font-serif text-[22px] mt-1 text-white">{v.title}</h3>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}
